@if (!productList) {
	<skeleton />
}
@if (productList) {
	<section>
		<custom-select [label]="'order-lines.product' | translate"
					[allowAutoFocus]="false"
					[selectList]="productList"
					[value]="selectedProduct"
					(valueChange)="selectProduct($event)"
					[autoSort]="true"
					[required]="true"></custom-select>

		@if (!variantLists || variantLists.length === 0) { <spacer /> }
		@for (variantList of variantLists; track variantList) {
			<div>
				<custom-select [label]="variantList.list.name"
							[selectList]="variantList.listOptions"
							[value]="getSelectedListOption(variantList.list)"
							(valueChange)="selectListOption($event)"
							[autoSort]="true"
							[required]="true"></custom-select>
			</div>
		}
		<custom-select [label]="'order-lines.payment-interval' | translate"
					[selectList]="availableIntervals"
					[disabled]="!selectedProduct?.autoRenew"
					[value]="orderLine.numberOfInstallments == undefined ? orderLine.paymentInterval : 0"
					(valueChange)="setPaymentInterval($event)"
					[required]="true"></custom-select>
		<custom-input [label]="'order-lines.total-price' | translate"
					[inputType]="inputType.Currency"
					[required]="true"
					[(value)]="orderLine.totalPrice"
					[customValidState]="orderLine.totalPrice >= 0"
					(valueChange)="totalPriceHasBeenEdited = true"></custom-input>
		<div>
			<custom-input [label]="'order-lines.no-startup' | translate"
					[inputType]="inputType.Switch"
					[disabled]="orderLine.numberOfInstallments != undefined"
					[value]="orderLine.startupAmountExclFirstInvoice === undefined"
					(valueChange)="orderLine.startupAmountExclFirstInvoice = $event ? undefined : 0"></custom-input>
		</div>
		<div>
			<custom-input [label]="'order-lines.startup-excl-first-invoice' | translate"
					[inputType]="inputType.Currency"
					[disabled]="orderLine.startupAmountExclFirstInvoice === undefined"
					[customValidState]="(orderLine.startupAmountExclFirstInvoice ?? 0) <= orderLine.totalPrice && (orderLine.startupAmountExclFirstInvoice ?? 0) >= 0"
					[(value)]="orderLine.startupAmountExclFirstInvoice"></custom-input>
		</div>
	</section>

	<section><ng-content /></section>
}
